import type { BackendDomainRow } from '../../repositoryblueprint/framework';

type Props = { items?: BackendDomainRow[] };

export function BackendDomainPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.domain} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.domain}</p>
            <p className="font-mono text-xs text-brand-600">{item.path}</p>
          </div>
          <p className="mt-1 text-xs text-slate-500">Depends on: {item.dependencies}</p>
          <p className="text-xs text-slate-500">API: {item.publicApi}</p>
        </div>
      ))}
    </div>
  );
}
